<div class="loading-dialog-content">
  <txp-loading
    [color]="loadingColor.COLOR"
    class="loading"
    [type]="loadingType.INLINE"
  ></txp-loading>
  <div class="loading-label">{{ data?.label || ('app.loading.processing' | translate) }}</div>
</div>
